import React from "react";
import "@frameworks/web/stylesheets/components/generic/radioButton.scss";
var RadioButton = function (props) {
    var _a;
    var _b = props.avoidchekmark, avoidchekmark = _b === void 0 ? true : _b;
    var moduleName = props.moduleName ? props.moduleName : "";
    return (React.createElement("div", { className: "radio-button ".concat(props.className, " ").concat(props.selected === props.list.value ? "child-radio-checked" : "") },
        React.createElement("label", { className: "radio_btn " + moduleName },
            React.createElement("input", { type: "radio", value: (_a = props.list.value) === null || _a === void 0 ? void 0 : _a.toString(), name: props.name, checked: props.selected === props.list.value, onChange: props.onChange, disabled: props.disabled ? props.disabled : false }),
            avoidchekmark ? React.createElement(React.Fragment, null) : React.createElement("span", { className: "checkmark" }), props === null || props === void 0 ? void 0 :
            props.bottomChildComp,
            React.createElement("span", { className: "disp_val DMSans_16_500 txt_blackOne1" }, props.list.display))));
};
export default RadioButton;
